import { Logger, Utils } from "neo-common";
import { IAnimationFrame, EventEmmiterClass, BaseElementClass } from "./Types";
import { AnimationFramePool } from "./Pool";
import { BaseElement } from "../Components/Elements/Graphics/BaseElement";

export function AnimationFrameClass(Superclass?: FunctionConstructor) {
    var sc: FunctionConstructor = (Superclass || Object) as any;

    return class AnimationFrame extends sc implements IAnimationFrame {
        private _frame_stopped: boolean;
        private _frame_starting: boolean;
        private _frame_stopping: boolean;
        private _frame_uid: string;

        constructor() {
            super();
            this._frame_stopped = true;
            this._frame_starting = null;
            this._frame_stopping = null;
            this._frame_uid = null;

            this.frame_draw = this.frame_draw.bind(this);
        }

        protected frame_onFrame(): void {
            throw new Error(`method "frame_onFrame" is not implemented!`);
        }

        protected get frame_name(): string {
            throw new Error(`property "frame_name" is not implemented!`);
        }

        protected get isFrameStopped(): boolean {
            return this._frame_stopped;
        }

        public get frame_uid(): string {
            if (this._frame_uid === null) {
                this._frame_uid = this.frame_name + Utils.generateUuid();
            }

            return this._frame_uid;
        }

        public frame_draw(): void {
            if (this._frame_stopped) {
                return;
            }

            this.frame_onFrame();
        }

        private frame_log(msg: string, isError?: boolean): void {
            isError = Utils.valueOrDefault(isError, false);

            if (DEBUG && !isError) {
                Logger.debugGroup("AnimationFrame", `[${this.frame_name}-AnimationFrame] ` + msg);
            }

            if (isError) {
                Logger.errorGroup("AnimationFrame", `[${this.frame_name}-AnimationFrame] ` + msg);
            }
        }

        public frame_start(): void {
            if (!this._frame_stopped) {
                return;
            }

            if (this._frame_starting) {
                return;
            }

            this._frame_starting = true;

            try {
                if (AnimationFramePool.registerFrame(this)) {
                    this._frame_stopped = false;
                    //this.frame_log('was started and registered to stage pool');
                } else {
                    this.frame_log("failed to start (already registered in stage pool!)", true);
                }
            } finally {
                this._frame_starting = null;
            }

            // this will do possible precalculations before actual method is called from 'requestAnimationFrame' from StageController
            this.frame_draw();
        }

        public frame_stop(): void {
            if (this._frame_stopped) {
                return;
            }

            if (this._frame_stopping) {
                return;
            }

            this._frame_stopping = true;

            try {
                if (AnimationFramePool.unregisterFrame(this)) {
                    this._frame_stopped = true;
                    //this.frame_log('was stopped and unregistered from stage pool');
                } else {
                    this.frame_log("failed to stop (not registered in stage pool!)", true);
                }
            } finally {
                this._frame_stopping = null;
            }
        }
    };
}

/**
 * abstract class AnimationFrameEventEmitter, extends both 'PIXI.utils.EventEmitter' and 'AnimationFrame' classes
 */
export abstract class AnimationFrameEventEmitter extends AnimationFrameClass(EventEmmiterClass() as any) {
    protected get super2(): PIXI.utils.EventEmitter {
        return this as any as PIXI.utils.EventEmitter;
    }
}

/**
 * abstract class AnimationFrameBaseElement, extends both 'BaseElement' and 'AnimationFrame' classes
 */
export abstract class AnimationFrameBaseElement extends AnimationFrameClass(BaseElementClass() as any) {
    protected get super2(): BaseElement {
        return this as any as BaseElement;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/AnimationFrame/AnimationFrame.ts
 **/